// Generic "how many rows should the loading skeleton show" cache, backed by
// localStorage. See docs/skeleton_count_caching.md for the full pattern and
// how to wire a new page up to it — this file only holds the primitive.
const PREFIX = 'skeleton_count:'

export function getCachedSkeletonCount(key, defaultCount) {
  const raw = localStorage.getItem(PREFIX + key)
  if (raw === null) return defaultCount

  const stored = Number(raw)
  // 0 is a legitimate cached count (a genuinely empty page) — only an
  // absent key (never cached) or a malformed value falls back to the default.
  return Number.isInteger(stored) && stored >= 0 ? stored : defaultCount
}

export function setCachedSkeletonCount(key, count) {
  try {
    localStorage.setItem(PREFIX + key, String(count))
  } catch {
    // Storage unavailable (private browsing, disabled site data, etc.) — skip
    // caching. The skeleton just falls back to its default next load, which
    // is the same experience as today, so this is safe to swallow.
  }
}
